import { Injectable } from "@angular/core";
import { SFCompanyApi } from "../../shared/sdk/services/custom/SFCompany";
import { Observable } from "rxjs/Observable";
import { NestApiProvider } from "../../shared/nestjs/nest-api";
import { SfCompanyApi } from "../../shared/nestjs/gd-only/services/sf-company.api";
import { map } from "rxjs/operators";
import { GDAuthInterface } from "../../model/gd-auth";
import { AppPreferences, Preference } from "../../shared/local/app-preferences.local";
import moment from "moment";
import { AnnouncementProvider } from "../../shared/nestjs/announcement/announcement";
import { ResponseGetAnnoucementDto } from "../../shared/nestjs/gd-only/dto/home-feed.dto";
import { BuilderServiceApi } from "../../shared/sdk";

@Injectable()
export class CompanyBloc {

	private _myCompany = {
		companyName: null,
		taxCountry: null, 
		urlLogo: null
	}

	private _loadingAnnoucement = false;
	private _announcementDashboard: ResponseGetAnnoucementDto[] = [];

	constructor(
		private nestApiProvider: NestApiProvider,
		private companyLB: SFCompanyApi,
		private companyNest: SfCompanyApi,
		private appPreferences: AppPreferences,
		private announcementProvider: AnnouncementProvider,
		private builderServiceApi: BuilderServiceApi,
	) {

	}

	/**
	 * Company
	 */
	private company(companyId: number): Observable<any> {
		return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
			.mergeMap(isGoPathNewExist => {
				if (isGoPathNewExist) {
					return this.companyNest.getCompany({ companyId: companyId }).pipe(
						map(param => param.data)
					)
				} else {
					return this.companyLB.getCompany({ 'companyId': companyId })
						.pipe(
							map(result => {
								return result[0];
							})
						)
				}
			})
	}

	/**
	 * Get detail company
	 */
	public async getCompany(companyId: number) {
		try {
			const company = await this.company(companyId).toPromise();
			return company;
		} catch (error) {
			throw error;
		}
	}

	doGetMyCompany() {
		try {
			if (this.appPreferences.dataAuth.hasOwnProperty('company') && this.appPreferences.dataAuth.company.companyName) {
				this._myCompany.companyName = this.appPreferences.dataAuth.company.companyName;
				this._myCompany.taxCountry = this.appPreferences.dataAuth.company.taxcountry;
				this._myCompany.urlLogo = this.appPreferences.dataAuth.company.companyLogo;

				const data = {
					companyName: this.appPreferences.dataAuth.company.companyName,
					taxcountry: this.appPreferences.dataAuth.company.taxcountry,
					companyLogo: this.appPreferences.dataAuth.company.companyLogo
				}

				this.appPreferences.setGreatdayStorage(Preference.Company, data);
			} else {
				this.getCompanyFromServer(this.appPreferences.dataAuth.companyId);
			}
		} catch (error) {
			this.getCompanyFromServer(this.appPreferences.dataAuth.companyId);
		}
		return;
	}

	private async getCompanyFromServer(companyId) {
		try {
			const myCompany = await this.getCompany(companyId);
			this._myCompany.companyName = myCompany.companyName;
			this._myCompany.taxCountry = myCompany.taxcountry;
			this._myCompany.urlLogo = myCompany.companyLogo;
			this.appPreferences.setGreatdayStorage(Preference.Company, myCompany);
		} catch (error) { }
	}

	get myCompany() {
		return this._myCompany;
	}

	get loadingAnnoucement() {
		return this._loadingAnnoucement;
	}

	get announcementDashboard() {
		return this._announcementDashboard;
	}

	getAnnouncement(auth: GDAuthInterface, page?: number, limit?: number): Promise<any> {
		return new Promise(async (resolve) => {
			if (auth.isSF6) {
				await this.getAnnouncementSF6();
			} else {
				await this.getAnnoucementGD(page, limit);
			}
			resolve(true);
		})
	}

	getAnnoucementGD(page = 1, limit = 3) {
		return new Promise(async (resolve) => {
			try {
				this._loadingAnnoucement = true;
				const result = await this.announcementProvider.getAnnouncement(page, limit).toPromise();

				const now = moment(new Date()); //todays date
				let index = 0;
				if (result.data.length > 0) {
					let temporary = [];
					for (let item of result.data) {
						if (index < 3) {
							let duration = moment.duration(now.diff(moment(item.createdDate.raw))).asDays();
							item.createdDate.duration = duration;
							item.preview = item.description.replace(/(\<br\s*\/?\>\s*)+/gi, '\n').replace(/^\<br>/i, '');
							temporary.push(item);
						}
						index++;
					}

					this._announcementDashboard = temporary;
				}

				await this.appPreferences.setGreatdayStorage(Preference.Announcement, this._announcementDashboard);
				this._loadingAnnoucement = false;
			} catch (error) {
				this._loadingAnnoucement = false;
			}

			resolve(true);
		})
	}

	getAnnouncementSF6() {
		return new Promise(async (resolve) => {
			const language = await this.appPreferences.getGreatdayStorage(Preference.Language);
			const params = { param: [{
				paramKey: "limit",
				paramValue: 10
			},
			{
				paramKey: "page",
				paramValue: 1
			},
			{
				paramKey: "lang",
				paramValue: language || 'en'
			}]}

			try {
				this._loadingAnnoucement = true;
				const result = await this.announcementProvider.getAnnouncementSf6(params).toPromise();
				let now = moment(new Date()); //todays date
				let index = 0;

				if (result.data.length > 0) {
					let temporary = [];
					for (let item of result.data) {
						if (index < 3) {
							let duration = moment.duration(now.diff(moment(item.createdDate.raw))).asDays();
							item.createdDate.duration = duration;
							item.preview = item.description.replace(/(\<br\s*\/?\>\s*)+/gi, '\n').replace(/^\<br>/i, '');
							temporary.push(item);
						}

						index++;
					}

					this._announcementDashboard = temporary;
				}

				await this.appPreferences.setGreatdayStorage(Preference.Announcement, this._announcementDashboard);
				this._loadingAnnoucement = false;
			} catch (error) {
				this._loadingAnnoucement = false;
			}

			resolve(true)
		})
	}

	public async cfcDirectApi(route, param = {}, body = {}): Promise<any> {
		return new Promise((resolve, reject) => {
			// console.log('TCL:TCL:cfcDirectApi', route, param, body);
			const interval = 15 * 60 * 1000;
			this.builderServiceApi.cfcDirect(route, param, body)
				.timeout(interval)
				.subscribe((result) => {
					resolve(result);
				}, error => {
					console.log('TCL:TCL:cfcDirectApi Error', error);
					reject(error);
				});
		})
	}
}


// WEBPACK FOOTER //
// ./src/bloc/company/company.bloc.ts